module.exports = __webpack_public_path__ + "static/media/bg_company.6f81787b.svg";